var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPositivePerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 247,
    viewBox: "0 0 336 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.864 149.697H262.509C270.089 149.697 276.235 155.825 276.235 163.384V238.66H162.138V163.384C162.138 155.825 168.283 149.697 175.864 149.697Z",
    fill: "#0ACC94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M335.857 235.392H36.0303V246.94H335.857V235.392Z",
    fill: "#E5E9F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.566 237.377H258.648V162.528C258.648 155.205 252.695 149.269 245.351 149.269H175.863C168.52 149.269 162.566 155.205 162.566 162.528V237.377ZM258.648 237.377H259.077L258.648 237.804V237.377Z",
    stroke: "white",
    strokeWidth: 2.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M216.398 116.764C228.361 116.764 238.059 107.093 238.059 95.1645C238.059 83.2356 228.361 73.5654 216.398 73.5654C204.434 73.5654 194.736 83.2356 194.736 95.1645C194.736 107.093 204.434 116.764 216.398 116.764Z",
    fill: "url(#paint0_linear_185_7235)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.147 135.571L168.471 132.09C166.946 128.922 166.745 125.28 167.912 121.964C171.74 111.084 180.686 105.643 194.749 105.643C214.071 109.357 217.765 124.059 205.832 149.752L182.159 145.301L170.147 135.571Z",
    fill: "url(#paint1_linear_185_7235)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.3 162.666L216.815 163.128C236.102 163.343 252.873 176.367 257.804 194.961L268.56 235.515L162.77 235.392L165.141 219.479C160.207 218.001 157.409 212.815 158.891 207.895C159.23 206.77 159.779 205.72 160.51 204.799L161.358 203.73L124.949 224.057L113.61 192.674L152.408 168.966C159.292 164.76 167.226 162.576 175.3 162.666Z",
    fill: "url(#paint2_linear_185_7235)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.514 202.318L180.936 176.306C179.942 175.684 178.633 175.957 177.972 176.923C177.296 177.91 177.469 179.245 178.373 180.029L183.225 184.239L175.965 187.466C175.141 187.832 174.714 188.746 174.962 189.611C175.201 190.443 176.072 190.924 176.907 190.686C176.907 190.686 176.907 190.686 176.907 190.686L185.445 188.244L187.952 189.772L178.799 192.39C177.847 192.662 177.296 193.653 177.569 194.602C177.849 195.576 178.827 196.176 179.825 195.987L188.245 194.393L193.065 195.488L181.75 198.724C180.992 198.941 180.554 199.73 180.771 200.486C180.998 201.277 181.763 201.79 182.584 201.703L192.912 200.6L215.435 218.463L222.514 202.318Z",
    fill: "url(#paint3_linear_185_7235)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M183.412 184.889L185.379 184.24C186.59 183.84 187.901 183.866 189.094 184.314L192.042 185.419",
    stroke: "#18233D",
    strokeWidth: 4.2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M187.33 190.722L189.297 190.072C190.508 189.673 191.819 189.699 193.012 190.146L195.96 191.251",
    stroke: "#18233D",
    strokeWidth: 4.2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M191.851 196.734L193.818 196.085C195.028 195.685 196.339 195.711 197.533 196.159L200.48 197.264",
    stroke: "#18233D",
    strokeWidth: 4.2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5442 172.378L73.2571 158.553C70.6137 156.31 67.0656 155.436 63.6787 156.196L47.9665 146.366C46.9726 145.745 45.6635 146.017 45.0021 146.984C44.3273 147.97 44.5017 149.304 45.4076 150.084L56.6929 159.808C54.767 160.254 53.2635 161.754 52.8185 163.674L52.761 163.923C50.9411 163.687 49.2742 164.967 49.0378 166.781C49.0193 166.923 49.0101 167.066 49.0101 167.208L49.0101 168.16L48.5382 168.514C46.9125 169.734 46.5398 172.014 47.6931 173.686C52.7389 178.516 54.5006 179.546 55.0413 179.767C55.582 179.988 56.2551 179.953 57.0606 179.662L82.4653 188.523L89.5442 172.378Z",
    fill: "url(#paint4_linear_185_7235)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5259 168.953C50.6146 169.012 50.6994 169.077 50.7799 169.148L57.3789 174.906C58.5151 175.898 58.6654 177.606 57.7197 178.78C56.8026 179.918 55.134 180.099 53.9926 179.184C53.9797 179.174 53.9669 179.164 53.9542 179.153L47.9847 174.184L47.603 173.866",
    stroke: "#18233D",
    strokeWidth: 2.4624,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5688 165.094C54.6575 165.154 54.7424 165.219 54.8229 165.289L61.4218 171.048C62.558 172.039 62.7083 173.747 61.7626 174.921C60.8456 176.059 59.1769 176.24 58.0356 175.326C58.0227 175.316 58.0099 175.305 57.9972 175.295L52.0276 170.325L51.6459 170.007",
    stroke: "#18233D",
    strokeWidth: 2.4624,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8589 161.245C58.9476 161.305 59.0324 161.37 59.1129 161.44L65.7119 167.198C66.8481 168.19 66.9984 169.898 66.0527 171.072C65.1356 172.21 63.467 172.391 62.3256 171.477C62.3127 171.466 62.2999 171.456 62.2872 171.445L56.3177 166.476L55.936 166.158",
    stroke: "#18233D",
    strokeWidth: 2.4624,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6795 156.196L57.3485 170.615C57.0028 171.402 57.3626 172.32 58.1523 172.665C58.1586 172.667 58.165 172.67 58.1714 172.673C59.0557 173.045 60.0773 172.857 60.7696 172.194L67.3816 165.864L68.0972 173.037C68.3194 175.264 69.3746 177.325 71.0527 178.81",
    fill: "#F39A93"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6795 156.196L57.3485 170.615C57.0028 171.402 57.3626 172.32 58.1523 172.665C58.1586 172.667 58.165 172.67 58.1714 172.673C59.0557 173.045 60.0773 172.857 60.7696 172.194L67.3816 165.864L68.0973 173.037C68.3194 175.264 69.3746 177.325 71.0527 178.81",
    stroke: "#18233D",
    strokeWidth: 2.4624,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2789 159.775L66.9297 185.221L113.413 219.525C119.296 223.867 127.591 222.652 131.973 216.807L132.987 215.456C137.361 209.622 136.196 201.363 130.379 196.958L81.2789 159.775Z",
    fill: "url(#paint5_linear_185_7235)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.693 128.429C168.693 133.703 170.034 138.891 172.591 143.509L175.842 149.38C177.83 152.972 181.62 155.202 185.734 155.202V163.79L191.205 181.908L213.717 163.79L203.196 140.273L205.842 138.243C207.276 137.142 208.029 135.374 207.828 133.58C207.637 131.876 206.321 130.513 204.621 130.258L204.245 130.201C202.36 129.918 200.544 131.026 199.938 132.828L199.182 135.077C185.638 133.077 177.48 129.876 174.709 125.472C173.83 128.248 171.824 129.234 168.693 128.429Z",
    fill: "url(#paint6_linear_185_7235)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M175.917 138.121C175.338 138.244 174.748 137.781 174.6 137.088C174.452 136.394 174.801 135.733 175.38 135.61C175.959 135.488 176.549 135.951 176.697 136.644C176.845 137.337 176.496 137.999 175.917 138.121Z",
    fill: "#18233D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M186.211 136.411C185.633 136.533 185.043 136.07 184.895 135.377C184.747 134.683 185.096 134.022 185.675 133.899C186.254 133.777 186.844 134.24 186.992 134.933C187.14 135.627 186.79 136.288 186.211 136.411Z",
    fill: "#18233D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M178.734 137.555C177.897 140.473 177.517 142.113 177.594 142.476C177.672 142.839 178.178 142.921 179.115 142.723",
    stroke: "#18233D",
    strokeWidth: 2.4624,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.366 145.935L184.979 144.959C184.627 146.784 183.9 147.813 182.798 148.046C181.696 148.279 180.885 147.576 180.366 145.935Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M187.277 131.386C185.453 130.856 183.878 131.053 182.553 131.979",
    stroke: "#18233D",
    strokeWidth: 3.6936,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M175.88 132.394C174.856 131.764 173.652 131.863 172.266 132.688",
    stroke: "#18233D",
    strokeWidth: 3.6936,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.734 155.202C191.901 155.257 196.565 153.267 199.726 149.231C196.111 156.469 191.447 160.672 185.734 161.84V155.202Z",
    fill: "#0D152A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4737 142.854L172.233 142.854C174.7 142.854 176.75 144.748 176.938 147.201L181.482 206.652C181.68 209.243 179.734 211.503 177.136 211.701C177.017 211.71 176.897 211.714 176.777 211.714H82.9526C80.2616 211.714 78.0247 209.647 77.8202 206.972L73.3413 148.376C73.1253 145.55 75.248 143.084 78.0825 142.869C78.2126 142.859 78.3431 142.854 78.4737 142.854V142.854Z",
    fill: "#18233D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6133 142.854L168.373 142.854C170.839 142.854 172.89 144.748 173.077 147.201L177.622 206.652C177.82 209.243 175.874 211.503 173.276 211.701C173.156 211.71 173.037 211.714 172.917 211.714H79.0922C76.4012 211.714 74.1644 209.647 73.9599 206.972L69.481 148.376C69.2649 145.55 71.3876 143.084 74.2221 142.869C74.3523 142.859 74.4828 142.854 74.6133 142.854V142.854Z",
    fill: "url(#paint7_linear_185_7235)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.504 189.901L143.694 211.714H106.806L110.909 191.051L134.504 189.901Z",
    fill: "#58627A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.551 189.901H134.686L129.286 229.835L128.729 233.955L103.374 228.189L108.551 189.901ZM119.622 215.453C122.465 215.453 124.769 213.112 124.769 210.224C124.769 207.336 122.465 204.995 119.622 204.995C116.779 204.995 114.474 207.336 114.474 210.224C114.474 213.112 116.779 215.453 119.622 215.453Z",
    fill: "#18233D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.817 189.901H133.482L127.991 227.991C127.721 229.862 129.023 231.596 130.899 231.865C131.061 231.888 131.224 231.9 131.387 231.9H146.351C148.2 231.9 149.699 233.394 149.699 235.238H126.946H106.716C103.636 235.238 101.14 232.749 101.14 229.678C101.14 229.413 101.159 229.149 101.196 228.887L106.817 189.901ZM117.466 215.385C120.366 215.385 122.718 213.067 122.718 210.209C122.718 207.35 120.366 205.032 117.466 205.032C114.565 205.032 112.213 207.35 112.213 210.209C112.213 213.067 114.565 215.385 117.466 215.385Z",
    fill: "url(#paint8_linear_185_7235)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M335.857 235.392H36.0303V246.94H335.857V235.392Z",
    fill: "#E5E9F3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_185_7235",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 283,
    y: 210,
    width: 35,
    height: 26
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M283.955 210.322L289.952 235.984H313.452L317.346 210.322H283.955Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_185_7235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.955 210.322L289.952 235.984H313.452L317.346 210.322H283.955Z",
    fill: "url(#paint9_linear_185_7235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.236 220.574L287.409 221.145C289.476 222.153 291.911 222.065 293.899 220.91L294.804 220.384C296.205 219.57 297.942 219.593 299.321 220.445C300.726 221.312 302.466 221.446 303.987 220.803L304.181 220.721C305.839 220.021 307.725 220.104 309.314 220.948L309.764 221.186C311.553 222.136 313.742 221.905 315.292 220.602L316.468 219.614",
    stroke: "white",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.236 223.995L287.409 224.567C289.476 225.575 291.911 225.486 293.899 224.331L294.804 223.805C296.205 222.991 297.942 223.015 299.321 223.866C300.726 224.734 302.466 224.868 303.987 224.225L304.181 224.143C305.839 223.443 307.725 223.526 309.314 224.369L309.764 224.608C311.553 225.557 313.742 225.326 315.292 224.024L316.468 223.036",
    stroke: "white",
    strokeWidth: 2.4
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.9 180.591L300.267 179.641C299.414 179.418 298.871 178.583 299.015 177.716C299.17 176.783 298.763 175.847 297.976 175.321L297.581 175.057C296.643 174.431 296.379 173.171 296.988 172.224C297.13 172.002 297.272 171.781 297.414 171.56C297.263 171.319 297.111 171.078 296.96 170.837C296.392 169.933 296.666 168.741 297.573 168.175C297.624 168.143 297.676 168.114 297.73 168.087L298.152 167.875C298.983 167.457 299.995 167.754 300.468 168.553L300.621 168.812C301.033 169.509 301.838 169.874 302.636 169.727C303.276 169.609 303.891 170.03 304.01 170.668C304.02 170.721 304.026 170.774 304.028 170.827L304.105 172.448C304.15 173.424 304.981 174.178 305.96 174.132C305.981 174.131 306.003 174.13 306.024 174.128C306.545 174.084 307.002 174.47 307.045 174.989C307.062 175.185 307.016 175.382 306.915 175.551L303.9 180.591Z",
    fill: "#0ACC94"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M302.548 210.261L304.676 181.706L299.89 172.495",
    stroke: "#18233D",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.742 190.435V187.295C302.742 186.447 302.094 185.738 301.247 185.658C300.332 185.572 299.546 184.976 299.219 184.119L299.111 183.836C298.748 182.884 297.716 182.368 296.734 182.646C296.45 182.726 296.165 182.807 295.881 182.888C295.686 182.699 295.492 182.51 295.298 182.32C294.531 181.575 293.305 181.589 292.555 182.35L292.27 182.64C291.696 183.223 291.704 184.16 292.289 184.733C292.3 184.743 292.31 184.753 292.321 184.763L292.562 184.985C293.083 185.465 293.217 186.233 292.889 186.86C292.637 187.342 292.825 187.937 293.309 188.188C293.365 188.217 293.425 188.241 293.486 188.259L295.21 188.765C295.999 188.996 296.451 189.821 296.219 190.607C296.207 190.649 296.193 190.689 296.177 190.729C296.009 191.158 296.221 191.641 296.651 191.809C296.813 191.872 296.991 191.883 297.16 191.841L302.742 190.435Z",
    fill: "#0ACC94"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M303.974 191.192L295.807 185.026",
    stroke: "#18233D",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.856 182.861V179.721C305.856 178.873 306.503 178.163 307.351 178.084C308.265 177.998 309.052 177.401 309.379 176.545L309.486 176.262C309.849 175.31 310.882 174.793 311.864 175.072C312.148 175.152 312.432 175.233 312.717 175.313C312.911 175.124 313.106 174.935 313.3 174.746C314.066 174.001 315.293 174.014 316.043 174.776L316.328 175.066C316.902 175.649 316.893 176.586 316.309 177.159C316.298 177.169 316.287 177.179 316.276 177.189L316.035 177.411C315.515 177.891 315.381 178.659 315.709 179.286C315.961 179.768 315.773 180.363 315.289 180.614C315.232 180.643 315.173 180.667 315.111 180.685L313.388 181.19C312.599 181.422 312.147 182.247 312.379 183.033C312.391 183.074 312.405 183.115 312.421 183.155C312.589 183.584 312.376 184.067 311.946 184.235C311.784 184.298 311.606 184.309 311.437 184.267L305.856 182.861Z",
    fill: "#0ACC94"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M304.624 183.618L312.791 177.452",
    stroke: "#18233D",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.816 205.504V201.578C301.816 200.518 301.006 199.632 299.947 199.532C298.804 199.425 297.821 198.679 297.412 197.608L297.278 197.255C296.824 196.065 295.533 195.419 294.306 195.767C293.95 195.868 293.595 195.968 293.239 196.069C292.996 195.833 292.753 195.596 292.511 195.36C291.553 194.429 290.02 194.445 289.082 195.398L288.726 195.76C288.008 196.489 288.019 197.66 288.75 198.376C288.763 198.388 288.776 198.401 288.79 198.414L289.091 198.691C289.742 199.291 289.909 200.251 289.5 201.035C289.185 201.637 289.42 202.381 290.024 202.695C290.095 202.731 290.17 202.761 290.246 202.784L292.401 203.415C293.387 203.704 293.952 204.736 293.662 205.719C293.647 205.77 293.629 205.821 293.61 205.871C293.399 206.407 293.665 207.011 294.202 207.221C294.405 207.3 294.628 207.314 294.839 207.261L301.816 205.504Z",
    fill: "#0ACC94"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.278 199.871V195.946C305.278 194.885 306.088 193.999 307.146 193.9C308.29 193.793 309.273 193.047 309.681 191.976L309.816 191.622C310.27 190.433 311.56 189.787 312.788 190.134C313.143 190.235 313.499 190.336 313.854 190.437C314.097 190.2 314.34 189.964 314.583 189.728C315.541 188.796 317.074 188.813 318.012 189.765L318.368 190.127C319.086 190.856 319.075 192.027 318.344 192.743C318.331 192.756 318.317 192.769 318.304 192.781L318.003 193.059C317.352 193.659 317.185 194.619 317.594 195.402C317.909 196.005 317.674 196.748 317.07 197.062C316.999 197.099 316.924 197.129 316.847 197.151L314.693 197.783C313.707 198.072 313.142 199.103 313.432 200.086C313.447 200.138 313.465 200.189 313.484 200.239C313.694 200.775 313.429 201.379 312.891 201.588C312.689 201.668 312.466 201.681 312.255 201.628L305.278 199.871Z",
    fill: "#0ACC94"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M303.271 201.652L315.956 192.237",
    stroke: "#18233D",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M302.741 205.886L291.198 197.59",
    stroke: "#18233D",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_185_7235",
    x1: 216.398,
    y1: 73.5654,
    x2: 216.398,
    y2: 116.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#354970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18233D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_185_7235",
    x1: 189.914,
    y1: 105.643,
    x2: 189.914,
    y2: 149.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#354970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18233D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_185_7235",
    x1: 191.085,
    y1: 162.663,
    x2: 191.085,
    y2: 235.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9AA42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_185_7235",
    x1: 191.962,
    y1: 172.401,
    x2: 205.911,
    y2: 221.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_185_7235",
    x1: 59.6689,
    y1: 142.268,
    x2: 73.6177,
    y2: 191.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_185_7235",
    x1: 91.6884,
    y1: 157.188,
    x2: 108.714,
    y2: 225.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9AA42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_185_7235",
    x1: 191.205,
    y1: 125.472,
    x2: 191.205,
    y2: 181.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_185_7235",
    x1: 123.551,
    y1: 142.854,
    x2: 123.551,
    y2: 211.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_185_7235",
    x1: 125.419,
    y1: 189.901,
    x2: 125.419,
    y2: 235.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DBAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_185_7235",
    x1: 300.65,
    y1: 210.322,
    x2: 300.65,
    y2: 235.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB36F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8B6E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositivePerson);
export default __webpack_public_path__ + "static/media/PositivePerson.25ad982ac8da011f64c250ff5c608133.svg";
export { ForwardRef as ReactComponent };